

export default {
	name: '',
	mixins: [],
	extends: {},
	components: {},
	props: ['applyOption'],
	data() {
		return {};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {},
	updated() {},
	beforeDestroy() {},
	methods: {
		applyText(){
			if(this.applyOption == 'SMS'){
				return '簡訊'
			}else if(this.applyOption == 'eBill'){
				return '電子'
			}else{
				this.$router.push('/eBill/eBill/eBillHome');
			}
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/eBill/eBill.js